import { useState, useEffect } from "react";
import { API } from "../../../api";
import "../../../styles/admin/EnterprisePropertiesEditor.css";

export default function EnterprisePropertiesEditor() {
	const [properties, setProperties] = useState({
		// Entreprise
		enterprise_email: { value: "", type: "string", label: "Email", category: "entreprise", section: "Coordonnées" },
		enterprise_phone: { value: "", type: "string", label: "Téléphone", category: "entreprise", section: "Coordonnées" },
		enterprise_address_street: { value: "", type: "string", label: "Rue", category: "entreprise", section: "Adresse" },
		enterprise_address_postal_code: { value: "", type: "number", label: "Code postal", category: "entreprise", section: "Adresse" },
		enterprise_address_city: { value: "", type: "string", label: "Ville", category: "entreprise", section: "Adresse" },
		enterprise_address_country: { value: "", type: "string", label: "Pays", category: "entreprise", section: "Adresse" },
		enterprise_gps_link: { value: "", type: "string", label: "Lien GPS", category: "entreprise", section: "Localisation" },
		enterprise_social_reason: { value: "", type: "string", label: "Raison sociale", category: "entreprise", section: "Informations légales" },
		enterprise_social_status: { value: "", type: "string", label: "Statut social", category: "entreprise", section: "Informations légales" },
		enterprise_siret: { value: "", type: "string", label: "SIRET", category: "entreprise", section: "Informations légales" },
		enterprise_rcs: { value: "", type: "string", label: "RCS", category: "entreprise", section: "Informations légales" },
		enterprise_vat_number: { value: "", type: "string", label: "Numéro TVA", category: "entreprise", section: "Informations légales" },
		enterprise_social_capital: { value: "", type: "string", label: "Capital social", category: "entreprise", section: "Informations légales" },
		enterprise_dirigent_first_name: { value: "", type: "string", label: "Prénom dirigeant", category: "entreprise", section: "Dirigeant" },
		enterprise_dirigent_last_name: { value: "", type: "string", label: "Nom dirigeant", category: "entreprise", section: "Dirigeant" },
		enterprise_developpeur_first_name: { value: "", type: "string", label: "Prénom développeur", category: "entreprise", section: "Développeur" },
		enterprise_developpeur_last_name: { value: "", type: "string", label: "Nom développeur", category: "entreprise", section: "Développeur" },
		enterprise_developpeur_mail: { value: "", type: "string", label: "Email développeur", category: "entreprise", section: "Développeur" },
		enterprise_developpeur_pub_url: { value: "", type: "string", label: "URL portfolio", category: "entreprise", section: "Développeur" },
		// Réseaux sociaux
		enterprise_social_media: { value: [], type: "json", label: "Réseaux sociaux", category: "reseaux", section: "Réseaux sociaux" },
		// Hébergement
		hebergement_name: { value: "", type: "string", label: "Nom", category: "hebergement", section: "Informations" },
		hebergement_website: { value: "", type: "string", label: "Site web", category: "hebergement", section: "Informations" },
		hebergement_email: { value: "", type: "string", label: "Email", category: "hebergement", section: "Coordonnées" },
		hebergement_phone: { value: "", type: "string", label: "Téléphone", category: "hebergement", section: "Coordonnées" },
		hebergement_address_street: { value: "", type: "string", label: "Rue", category: "hebergement", section: "Adresse" },
		hebergement_address_postal_code: { value: "", type: "number", label: "Code postal", category: "hebergement", section: "Adresse" },
		hebergement_address_city: { value: "", type: "string", label: "Ville", category: "hebergement", section: "Adresse" },
		hebergement_address_country: { value: "", type: "string", label: "Pays", category: "hebergement", section: "Adresse" },
	});

	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(null);
	const [status, setStatus] = useState(null);
	const [activeCategory, setActiveCategory] = useState("entreprise");
	const [socialMedias, setSocialMedias] = useState([]);
	const [originalProperties, setOriginalProperties] = useState({});
	const [originalSocialMedias, setOriginalSocialMedias] = useState([]);

	useEffect(() => {
		fetchProperties();
	}, []);

	const fetchProperties = async () => {
		try {
			setLoading(true);
			const data = await API.get("globalproperties");
			
			const updatedProperties = { ...properties };
			if (Array.isArray(data)) {
				data.forEach(prop => {
					if (updatedProperties[prop.key]) {
						let value = prop.value;
						if (updatedProperties[prop.key].type === "number") {
							value = prop.value ? parseFloat(prop.value) : "";
						} else if (updatedProperties[prop.key].type === "json") {
							try {
								value = typeof prop.value === "string" ? JSON.parse(prop.value) : prop.value;
								if (prop.key === "enterprise_social_media") {
									setSocialMedias(value || []);
								}
							} catch (e) {
								value = [];
							}
						}
						updatedProperties[prop.key].value = value;
					}
				});
			}
			setProperties(updatedProperties);
			setOriginalProperties(JSON.parse(JSON.stringify(updatedProperties)));
			setStatus(null);
		} catch (error) {
			console.error("Erreur:", error);
			setStatus({ type: "error", message: "Impossible de charger les propriétés" });
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (key, value) => {
		setProperties(prev => ({
			...prev,
			[key]: { ...prev[key], value }
		}));
	};

	const isPropertyChanged = (key) => {
		if (!originalProperties[key]) return false;
		const currentValue = properties[key].value;
		const originalValue = originalProperties[key].value;
		return JSON.stringify(currentValue) !== JSON.stringify(originalValue);
	};

	const isSocialMediaChanged = () => {
		return JSON.stringify(socialMedias) !== JSON.stringify(originalSocialMedias);
	};

	const handleSave = async (key) => {
		const prop = properties[key];
		
		try {
			setSaving(key);
			setStatus(null);

			await API.put("globalproperties", {
				p_key: key,
				p_value: prop.value.toString(),
				p_type: prop.type
			});

			setOriginalProperties(prev => ({ ...prev, [key]: { ...prev[key], value: prop.value } }));
			setStatus({ type: "success", message: `${prop.label} mis à jour avec succès` });
			setTimeout(() => setStatus(null), 3000);
		} catch (error) {
			console.error("Erreur:", error);
			setStatus({ type: "error", message: `Erreur lors de la mise à jour` });
		} finally {
			setSaving(null);
		}
	};

	// Grouper les propriétés par catégorie et section
	const groupedProperties = Object.entries(properties).reduce((acc, [key, prop]) => {
		const category = prop.category;
		const section = prop.section;
		
		if (!acc[category]) acc[category] = {};
		if (!acc[category][section]) acc[category][section] = [];
		
		acc[category][section].push([key, prop]);
		return acc;
	}, {});

	const categoryLabels = {
		entreprise: "Entreprise",
		reseaux: "Réseaux sociaux",
		hebergement: "Hébergement"
	};

	const handleAddSocialMedia = () => {
		const newMedia = {
			social_media_icon: "",
			social_media_url: "",
			social_media_name: "",
			social_media_active: true,
			social_media_label: "",
			social_media_order: socialMedias.length + 1
		};
		const updated = [...socialMedias, newMedia];
		setSocialMedias(updated);
		setProperties(prev => ({
			...prev,
			enterprise_social_media: { ...prev.enterprise_social_media, value: updated }
		}));
	};

	const handleRemoveSocialMedia = (index) => {
		const updated = socialMedias.filter((_, i) => i !== index);
		setSocialMedias(updated);
		setProperties(prev => ({
			...prev,
			enterprise_social_media: { ...prev.enterprise_social_media, value: updated }
		}));
	};

	const handleUpdateSocialMedia = (index, field, value) => {
		const updated = [...socialMedias];
		updated[index] = { ...updated[index], [field]: value };
		setSocialMedias(updated);
		setProperties(prev => ({
			...prev,
			enterprise_social_media: { ...prev.enterprise_social_media, value: updated }
		}));
	};

	const handleSaveSocialMedia = async () => {
		try {
			setSaving("enterprise_social_media");
			setStatus(null);

			await API.put("globalproperties", {
				p_key: "enterprise_social_media",
				p_value: JSON.stringify(socialMedias),
				p_type: "json"
			});

			setOriginalSocialMedias(JSON.parse(JSON.stringify(socialMedias)));
			setStatus({ type: "success", message: "Réseaux sociaux mis à jour avec succès" });
			setTimeout(() => setStatus(null), 3000);
		} catch (error) {
			console.error("Erreur:", error);
			setStatus({ type: "error", message: `Erreur lors de la mise à jour` });
		} finally {
			setSaving(null);
		}
	};

	if (loading) {
		return (
			<div className="ent-editor-container">
				<div className="ent-loader">
					<div className="ent-spinner"></div>
					<p>Chargement de la configuration...</p>
				</div>
			</div>
		);
	}

	return (
		<div className="ent-editor-container">
			<div className="ent-header-section">
				<h1 className="ent-title">Gestion des Propriétés Globales</h1>
				<p className="ent-subtitle">Gérez les informations de l'entreprise, des réseaux sociaux et de l'hébergement</p>
			</div>

			{status && (
				<div className={`ent-status ent-status-${status.type}`}>
					<div className="ent-status-content">
						<span className="ent-status-icon">
							{status.type === "success" ? "✓" : "✕"}
						</span>
						<span>{status.message}</span>
					</div>
				</div>
			)}

			<div className="ent-tabs">
				{Object.entries(categoryLabels).map(([catKey, catLabel]) => (
					<button
						key={catKey}
						className={`ent-tab ${activeCategory === catKey ? "ent-tab-active" : ""}`}
						onClick={() => setActiveCategory(catKey)}
					>
						{catLabel}
					</button>
				))}
			</div>

			<div className="ent-content">
				{activeCategory === "reseaux" ? (
					<div className="ent-section">
						<h2 className="ent-section-title">Réseaux sociaux</h2>
						<div className="ent-social-media-list">
							{socialMedias.map((media, index) => (
								<div key={index} className="ent-social-media-card">
									<div className="ent-social-media-grid">
										<div className="ent-form-group">
											<label className="ent-label">Nom du réseau</label>
											<input
												type="text"
												value={media.social_media_name}
												onChange={(e) => handleUpdateSocialMedia(index, "social_media_name", e.target.value)}
												className="ent-input"
												placeholder="Ex: Facebook"
											/>
										</div>
										<div className="ent-form-group">
											<label className="ent-label">URL</label>
											<input
												type="text"
												value={media.social_media_url}
												onChange={(e) => handleUpdateSocialMedia(index, "social_media_url", e.target.value)}
												className="ent-input"
												placeholder="https://..."
											/>
										</div>
										<div className="ent-form-group">
											<label className="ent-label">Icône</label>
											<input
												type="text"
												value={media.social_media_icon}
												onChange={(e) => handleUpdateSocialMedia(index, "social_media_icon", e.target.value)}
												className="ent-input"
												placeholder="icon-name"
											/>
										</div>
										<div className="ent-form-group">
											<label className="ent-label">Libellé</label>
											<input
												type="text"
												value={media.social_media_label}
												onChange={(e) => handleUpdateSocialMedia(index, "social_media_label", e.target.value)}
												className="ent-input"
												placeholder="Suivez-nous..."
											/>
										</div>
										<div className="ent-form-group">
											<label className="ent-label">Ordre</label>
											<input
												type="number"
												value={media.social_media_order}
												onChange={(e) => handleUpdateSocialMedia(index, "social_media_order", parseInt(e.target.value))}
												className="ent-input"
												min="1"
											/>
										</div>
										<div className="ent-form-group ent-toggle-group">
											<label className="ent-label">Actif</label>
											<label className="ent-toggle">
												<input
													type="checkbox"
													checked={media.social_media_active}
													onChange={(e) => handleUpdateSocialMedia(index, "social_media_active", e.target.checked)}
												/>
												<span className="ent-toggle-slider"></span>
											</label>
										</div>
										<div className="ent-form-group ent-action-group">
											<button
												onClick={() => handleRemoveSocialMedia(index)}
												className="ent-btn-delete"
											>
												Supprimer
											</button>
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="ent-social-media-actions">
							<button onClick={handleAddSocialMedia} className="ent-btn-add">
								Ajouter un réseau social
							</button>
							<button
								onClick={handleSaveSocialMedia}
							disabled={saving === "enterprise_social_media" || !isSocialMediaChanged()}
								className={`ent-btn-save ${saving === "enterprise_social_media" ? "ent-loading" : ""}`}
							>
								{saving === "enterprise_social_media" ? "Enregistrement..." : "Sauvegarder"}
							</button>
						</div>
					</div>
				) : (
					groupedProperties[activeCategory] && Object.entries(groupedProperties[activeCategory]).map(([sectionName, items]) => (
						<div key={sectionName} className="ent-section">
							<h2 className="ent-section-title">{sectionName}</h2>
							<div className="ent-properties-grid">
								{items.map(([key, prop]) => (
									<div key={key} className="ent-property-card">
										<div className="ent-card-inner">
											<div className="ent-card-content">
												<label htmlFor={key} className="ent-card-title">{prop.label}</label>
												<div className="ent-input-wrapper">
													{prop.type === "number" ? (
														<input
															id={key}
															type="number"
															value={prop.value}
															onChange={(e) => handleChange(key, parseFloat(e.target.value) || "")}
															disabled={saving === key}
															className="ent-input"
															step="1"
														/>
													) : (
														<input
															id={key}
															type="text"
															value={prop.value}
															onChange={(e) => handleChange(key, e.target.value)}
															disabled={saving === key}
															className="ent-input"
														/>
													)}
												</div>
											</div>
											<button
												onClick={() => handleSave(key)}
											disabled={saving === key || !isPropertyChanged(key)}
												className={`ent-btn-save ${saving === key ? "ent-loading" : ""}`}
											>
												{saving === key ? "Enregistrement..." : "Sauvegarder"}
											</button>
										</div>
									</div>
								))}
							</div>
						</div>
					))
				)}
			</div>
		</div>
	);
}
